<template>
	<svg
		id="main-resource-bg"
		class="main-resource-bg"
		:class="{ 'main-resource-bg--not-enough': type === 'danger' }"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 265 135"
	>
		<linearGradient
			id="linear-gradient"
			x1="83.5"
			y1="27.5"
			x2="181.5"
			y2="27.5"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stop-color="#464550" />
			<stop offset="1" stop-color="#111015" />
		</linearGradient>
		<linearGradient
			id="linear-gradient-event"
			x1="0"
			y1="0"
			x2="0"
			y2="100%"
		>
			<stop offset="0" stop-color="#288f38" />
			<stop offset="1" stop-color="#0b3b1b" />
		</linearGradient>
		<g id="base">
			<path
				class="base"
				d="M181.45,51c.03-.66.05-1.33.05-2,0-27.06-21.94-49-49-49s-49,21.94-49,49c0,.67.02,1.34.05,2H0v84h265V51h-83.55Z"
			/>
		</g>
		<g id="bottom-right-corner">
			<polygon
				class="bottom-right-corner"
				points="265 51 265 135 0 135 4 131 261 131 261 55 265 51"
			/>
		</g>
		<g id="top-right-corner">
			<polygon
				class="top-right-corner"
				points="265 51 261 55 177.28 55 181.45 51 265 51"
			/>
		</g>
		<g id="top-left-corner">
			<polygon
				class="top-left-corner"
				points="87.72 55 4 55 4 131 0 135 0 51 83.55 51 87.72 55"
			/>
		</g>
		<g id="top-arch">
			<path
				class="top-arch"
				d="M181.5,49c0,.67-.02,1.34-.05,2l-4.17,4,.17-4.16c.03-.61.05-1.22.05-1.84,0-24.81-20.19-45-45-45s-45,20.19-45,45c0,.62.02,1.23.05,1.84l.17,4.16-4.17-4c-.03-.66-.05-1.33-.05-2C83.5,21.94,105.44,0,132.5,0s49,21.94,49,49Z"
			/>
		</g>
	</svg>
</template>

<script lang="ts" setup>
interface Props {
	type: "primary" | "danger";
}

const { type = "primary" } = defineProps<Props>();
</script>

<style lang="scss" scoped>
.main-resource-bg {
	.top-right-corner,
	.top-left-corner {
		fill: #464550;
	}
	.bottom-right-corner {
		fill: #111015;
	}
	.base {
		fill: #2e2d39;
	}
	.top-arch {
		fill: url(#linear-gradient);
	}

	&--not-enough {
		.top-arch,
		.top-right-corner,
		.top-left-corner,
		.bottom-right-corner {
			fill: #cf0032 !important;
		}
	}
}
</style>
